import type { ProposalExtraItemType } from '@econtractor/types';
import * as apiObject from 'api/apiObjects';
import vconst from 'utils/helpers/structs/vconst';

export const isProposalExtraAsOtherExpense = (
    item: Pick<ProposalExtraItemType, 'asOtherExpense'> | null | undefined,
    includeOtherInObjectCost: boolean,
): boolean => Boolean(includeOtherInObjectCost && item?.asOtherExpense);

const firstDescriptionLine = (value: unknown): string =>
    String(value ?? '')
        .split('\n')[0]
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

/** Чи вже є активний видаток «Інше» з такою назвою (перший рядок опису). */
export const hasMatchingOtherExpend = (expends: unknown, itemName: string): boolean => {
    const name = String(itemName || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    if (!name) return false;
    const list = Array.isArray(expends) ? expends : [];
    return list.some((item) => {
        if (!item || typeof item !== 'object') return false;
        const row = item as Record<string, unknown>;
        const status = Number(row.expendStatus ?? row.expend_status ?? 0);
        if (status === vconst.incomeStatCancel) return false;
        return firstDescriptionLine(row.expendDescription ?? row.expend_description) === name;
    });
};

export type AddProposalExtraAsOtherExpendParams = {
    objectId: number;
    itemName: string;
    itemCount: number;
    price: number;
    priceRate?: number;
    priceSale?: number;
    priceSaleRate?: number;
};

/** Додає позицію КП як видаток вкладки «Інше» (сума зі знаком мінус). */
export const addProposalExtraAsOtherExpend = async ({
    objectId,
    itemName,
    itemCount,
    price,
    priceRate,
    priceSale,
    priceSaleRate,
}: AddProposalExtraAsOtherExpendParams): Promise<boolean> => {
    const count = Number(itemCount) || 0;
    const unit = Number(price) || Number(priceSale) || 0;
    const amount = Math.round(count * unit * 100) / 100;
    if (!(objectId > 0) || !(amount > 0)) return false;

    const unitRate =
        priceRate != null && Number.isFinite(Number(priceRate))
            ? Number(priceRate)
            : priceSaleRate != null && Number.isFinite(Number(priceSaleRate))
              ? Number(priceSaleRate)
              : undefined;
    const amountRate =
        unitRate != null ? Math.round(count * unitRate * 100) / 100 : 0;

    const description = String(itemName || '').trim();

    return apiObject.addExpend({
        objectId,
        expendTypeId: vconst.expendTypeDefExpend,
        amount: -amount,
        amountRate: -amountRate,
        description,
    });
};
